import { __ } from "@wordpress/i18n";
import React from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const SecurityEmailBlacklist = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    return (
        <>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable email blacklist", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Block unwanted or suspicious email addresses from accessing your site. Prevent spam registrations, orders, and unauthorized activities by enabling the email blacklist feature.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/disable email blocklist for this site.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_blacklist.enable"
                                    checked={settingData?.security?.email_blacklist?.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Block these email addresses", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Specify email addresses to block. Prevent unwanted users from registering, or logging in on your site.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Enable/disable email blocklist for this site", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='security.email_blacklist.email_addresses' 
                                        type='email' 
                                        initialTags={settingData?.security?.email_blacklist?.email_addresses} 
                                        handleChange={handleChange} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityEmailBlacklist,'security.email_blacklist');